module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    staticClass: "agent-apply-dialog",
    attrs: {
      "close-on-click-modal": false,
      "title": _vm.title,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowContact),
      expression: "isShowContact"
    }],
    attrs: {
      "label": "经销商类型："
    }
  }, [_vm._v("\n                " + _vm._s(_vm.form.Industry_Name) + "\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowContact && _vm.form.Industry_Id == 9),
      expression: "isShowContact&&form.Industry_Id==9"
    }]
  }, [_c('h4', [_vm._v("联系人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主联系人："
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.contact.C_Name) + "\n                        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人电话：",
      "label-width": "100px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.contact.C_Tel) + "\n                        ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人地址："
    }
  }, [(_vm.contact.AreaName !== '') ? _c('span', [_vm._v(" " + _vm._s(_vm.contact.ProvName) + "-" + _vm._s(_vm.contact.CityName) + "-" + _vm._s(_vm.contact.AreaName))]) : _c('span', [_vm._v(" " + _vm._s(_vm.contact.ProvName) + "-" + _vm._s(_vm.contact.CityName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.contact.Address) + "\n                ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人身份证："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.contact.C_IDNumber_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowContact),
      expression: "isShowContact"
    }]
  }, [_c('h4', [_vm._v("公司基本信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.baseInfo.CustomerName) + "\n                ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属招商经理："
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.baseInfo.LeasingManagerName) + "\n                        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属业务经理："
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.baseInfo.BusEmployeeName) + "\n                        ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseInfo.SocialCreditCode !== ''),
      expression: "baseInfo.SocialCreditCode!==''"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "统一社会信用代码：",
      "label-width": "140px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.baseInfo.SocialCreditCode) + "\n                        ")])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.baseInfo.Corporation !== ''),
      expression: "baseInfo.Corporation!==''"
    }],
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司法定代表人：",
      "label-width": "130px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.baseInfo.Corporation) + "\n                        ")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Corporation_Drawing.length > 0),
      expression: "Corporation_Drawing.length>0"
    }],
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法人身份证："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.baseInfo.Corporation_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Company_Drawing.length > 0),
      expression: "Company_Drawing.length>0"
    }],
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "营业执照："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.baseInfo.Company_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司地址："
    }
  }, [(_vm.baseInfo.AreaName !== '') ? _c('span', [_vm._v(" " + _vm._s(_vm.baseInfo.ProvName) + "-- " + _vm._s(_vm.baseInfo.CityName) + "-- " + _vm._s(_vm.baseInfo.AreaName))]) : _c('span', [_vm._v(" " + _vm._s(_vm.baseInfo.ProvName) + "-- " + _vm._s(_vm.baseInfo.CityName))])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "数据类型："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.baseInfo.DataTypeName) + "\n                ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowContact && _vm.form.Industry_Id == 14),
      expression: "isShowContact&&form.Industry_Id==14"
    }]
  }, [_c('h4', [_vm._v("联系人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主联系人："
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.contact.C_Name) + "\n                        ")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人电话：",
      "label-width": "100px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.contact.C_Tel) + "\n                        ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系人地址："
    }
  }, [(_vm.contact.AreaName !== '') ? _c('span', [_vm._v(" " + _vm._s(_vm.contact.ProvName) + "-" + _vm._s(_vm.contact.CityName) + "-" + _vm._s(_vm.contact.AreaName))]) : _c('span', [_vm._v(" " + _vm._s(_vm.contact.ProvName) + "-" + _vm._s(_vm.contact.CityName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址："
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.contact.Address) + "\n                ")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人身份证："
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.contact.C_IDNumber_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    })])])
  }))])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agentInfo.Customer !== '' && !_vm.isShowContact),
      expression: "agentInfo.Customer!==''&&!isShowContact"
    }]
  }, [_c('h4', [_vm._v("代理商信息")]), _vm._v(" "), _c('el-form', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "代理商："
    }
  }, [_vm._v(_vm._s(_vm.agentInfo.Customer))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主联系人："
    }
  }, [_vm._v(_vm._s(_vm.agentInfo.C_Name))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人电话："
    }
  }, [_vm._v(_vm._s(_vm.agentInfo.AgentTel))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司所在区域："
    }
  }, [_vm._v(_vm._s(_vm.agentInfo.Address))])], 1)], 1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("合作信息")]), _vm._v(" "), _vm._l((_vm.agentList), function(item, index) {
    return _c('div', [_c('h5', [_vm._v("合作信息-" + _vm._s(index + 1))]), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "合作项目："
      }
    }, [_vm._v("\n                        " + _vm._s(item.ProjectTypeName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.PolicyTypeName !== ''),
        expression: "item.PolicyTypeName!==''"
      }],
      attrs: {
        "label": "合作政策："
      }
    }, [_vm._v("\n                        " + _vm._s(item.PolicyTypeName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.RebateLevelName !== ''),
        expression: "item.RebateLevelName!==''"
      }],
      attrs: {
        "label": "合作级别："
      }
    }, [_vm._v("\n                        " + _vm._s(item.RebateLevelName) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ContractNumber !== null),
        expression: "item.ContractNumber!==null"
      }],
      attrs: {
        "label": "合同号："
      }
    }, [_vm._v("\n                        " + _vm._s(item.ContractNumber) + "\n                    ")]), _vm._v(" "), _vm._l((item.AreaList), function(opts, index) {
      return _c('div', [_c('el-form-item', {
        attrs: {
          "label": '签约区域' + (index + 1)
        }
      }, [(opts.AreaName !== '') ? _c('span', [_vm._v(" " + _vm._s(opts.ProvName) + "-" + _vm._s(opts.CityName) + "-" + _vm._s(opts.AreaName))]) : _c('span', [_vm._v(" " + _vm._s(opts.ProvName) + "-" + _vm._s(opts.CityName))])])], 1)
    }), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "授权经销期限："
      }
    }, [_vm._v("\n                        " + _vm._s(item.StartDate) + " 至 " + _vm._s(item.EndDate) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.DefendStartDate !== ''),
        expression: "item.DefendStartDate!==''"
      }],
      attrs: {
        "label": "区域保护期限："
      }
    }, [_vm._v("\n                        " + _vm._s(item.DefendStartDate) + " 至 " + _vm._s(item.DefendEndDate) + "\n                    ")]), _vm._v(" "), _c('el-row', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.RebateLevel == 1),
        expression: "item.RebateLevel==1"
      }]
    }, [_c('el-col', {
      staticClass: "viewImgPos",
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      staticClass: "follow-endTime",
      attrs: {
        "label": "合作意向书："
      }
    }, [_c('ul', {
      staticClass: "img-list"
    }, _vm._l((item.CooperateIntent), function(img, index) {
      return _c('li', {
        staticClass: "img-box"
      }, [_c('img', {
        attrs: {
          "src": img.Url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "img-mask"
      }, [_c('i', {
        staticClass: "el-icon-view",
        on: {
          "click": function($event) {
            _vm.showImgView(img)
          }
        }
      })])])
    }))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "合同预付款："
      }
    }, [_vm._v("\n                        " + _vm._s(item.ContractMoney) + " 元\n                    ")]), _vm._v(" "), _c('el-row', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.RebateLevel !== 1),
        expression: "item.RebateLevel!==1"
      }]
    }, [_c('el-col', {
      staticClass: "viewImgPos",
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      staticClass: "follow-endTime",
      attrs: {
        "label": "经销合同协议："
      }
    }, [_c('ul', {
      staticClass: "img-list"
    }, _vm._l((item.HNC_Drawing), function(img, index) {
      return _c('li', {
        staticClass: "img-box"
      }, [_c('img', {
        attrs: {
          "src": img.Url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "img-mask"
      }, [_c('i', {
        staticClass: "el-icon-view",
        on: {
          "click": function($event) {
            _vm.showImgView(img)
          }
        }
      })])])
    }))])], 1)], 1), _vm._v(" "), _c('el-row', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ContractMoney > 0),
        expression: "item.ContractMoney>0"
      }]
    }, [_c('el-col', {
      staticClass: "viewImgPos",
      attrs: {
        "span": 24
      }
    }, [_c('el-form-item', {
      staticClass: "follow-endTime",
      attrs: {
        "label": "合同款打款凭证：",
        "label-width": "130px"
      }
    }, [_c('ul', {
      staticClass: "img-list"
    }, _vm._l((item.ContractMoney_Drawing), function(img, index) {
      return _c('li', {
        staticClass: "img-box"
      }, [_c('img', {
        attrs: {
          "src": img.Url
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "img-mask"
      }, [_c('i', {
        staticClass: "el-icon-view",
        on: {
          "click": function($event) {
            _vm.showImgView(img)
          }
        }
      })])])
    }))])], 1)], 1)], 2)
  })], 2), _vm._v(" "), _c('h4', [_vm._v("提交及审核记录")]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.AreaAduit.Id == ''),
      expression: "this.AreaAduit.Id==''"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form.LogList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "UserName",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OperTypeName",
      "label": "操作类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OperTime",
      "label": "时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OperStatusName",
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Contents",
      "label": "存疑模块"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "审核备注"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.AreaAduit.Id > 0),
      expression: "this.AreaAduit.Id>0"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.form.LogList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "UserName",
      "label": "操作人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OperTypeName",
      "label": "操作类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OperTime",
      "label": "时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OperStatusName",
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "审核备注"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isExamine) ? _c('el-form', {
    ref: "form",
    staticClass: "examine-form",
    attrs: {
      "label-width": "84px",
      "model": _vm.examineData
    }
  }, [_c('div', {
    staticClass: "cut-line"
  }), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核意见"
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.examineData.AuditStatus),
      callback: function($$v) {
        _vm.$set(_vm.examineData, "AuditStatus", $$v)
      },
      expression: "examineData.AuditStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "审核通过",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "审核不通过",
      "value": "1"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.examineData.AuditStatus == 1 && this.AreaAduit.Id == 0) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, _vm._l((_vm.examineData.ListDoubt), function(item, index) {
    return _c('el-form-item', {
      key: item.Module,
      attrs: {
        "label": '存疑模块' + (index + 1)
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "placeholder": "-请选择-"
      },
      model: {
        value: (item.Module),
        callback: function($$v) {
          _vm.$set(item, "Module", $$v)
        },
        expression: "item.Module"
      }
    }, _vm._l((_vm.ListDoubtTypes), function(option) {
      return _c('el-option', {
        key: option.id,
        attrs: {
          "value": option.id,
          "label": option.value
        }
      })
    })), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isAddBtnShow[index]),
        expression: "isAddBtnShow[index]"
      }],
      staticClass: "fa fa-plus-circle",
      on: {
        "click": _vm.addList
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isDelBtnShow[index]),
        expression: "isDelBtnShow[index]"
      }],
      staticClass: "fa fa-minus-circle",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeList(index)
        }
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "审核备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.examineData.AuditRemark),
      callback: function($$v) {
        _vm.$set(_vm.examineData, "AuditRemark", $$v)
      },
      expression: "examineData.AuditRemark"
    }
  })], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExamine),
      expression: "isExamine"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("审核")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d0469d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CRMAgentManage/components/viewDialog/index.vue
// module id = 1378
// module chunks = 1